<template>
	<div>
		<span
			v-if="people"
			v-text="'Ordina i kit ricette con porzioni per'"
		/>

		<div
			class="fake-dd-people"
			@click="openDropDown"
		>
			<span id="select-op-btn" v-if="people">
				{{ people }} persone
				<i class="fas fa-angle-down" />
			</span>

			<ul
				:class='{ "js-drop": !showDropDown }'
				v-if="plansStore.plans"
			>
				<li
					class="text-body-mid"
					v-for="i in [2, 4]"
					@click="onPeopleChange(i)"
					:key="i"
				>
					<span
						v-text="i + ' persone'"
					/>
				</li>
			</ul>
		</div>
	</div>
</template>

<script type = "text/javascript" >

import { orderStore } from '../../store/orderStore'
import { errorStore } from '../../store/errorStore'
import { plansStore } from '../../store/plansStore'
import { orderAction } from '../../mixins/orderAction'
import { Order } from '../../core/Order'

export default {
	mixins: [
		orderAction
	],
	props: {
		updating: {
			type: Boolean,
			default: false
		},
		extraParams: {
			type: Array,
			default () {
				return []
			}
		}
	},

	data () {
		return {
			orderStore: orderStore.state,
			errorStore: errorStore.state,
			plansStore: plansStore.state,

			showDropDown: false,

			people: null
		}
	},

	watch: {
		updating (newV, oldV) {
			if (newV) {
				// this.updateBasicInfo()
			}
		}
	},

	computed: {
		min () {
			if (!this.plansStore.selectedPlanId || !this.plansStore.plans) return
			return plansStore.getMinRecipes({ plan_id: this.plansStore.plans.find(plan => plan.people === this.people).id }) 
		},

		max () {
			if (!this.plansStore.selectedPlanId || !this.plansStore.plans) return
			return plansStore.getMaxRecipes({ plan_id: this.plansStore.plans.find(plan => plan.people === this.people).id })  
		}
	},

	methods: {	
		onPeopleChange (input) {
			this.people = input
			this.updateBasicInfo()
		},

		openDropDown () {
			this.showDropDown = !this.showDropDown
		},

		updateBasicInfo () {

			this.$emit('update:updating', true)

			errorStore.removeMessage()

				return plansStore.findPlan({
					people: this.people,
					meals: Object.values(this.recipes).map(a => a.quantity).reduce((a, b) => a + b, 0)
				})

			.then(plan => {

				this.order.plan.people = plan.people

				return this.$_orderAction_updateCurrentRecipes();
			})

			.then(response => {
				this.$emit('update:updating', false)
			})

			.catch(response => {
				this.errorHandle(response)
				this.$emit('update:updating', false)
			})
		},

		errorHandle (response) {
			let plan = this.plansStore.plans.find(plan => plan.people === this.people)

			if (!plan) {
				return
			}
			
			var params = {
				min: plansStore.getMinRecipes({ plan_id: plan.id }),
				max: plansStore.getMaxRecipes({ plan_id: plan.id }),
				people: this.people
			}

			var type = this.orderStore.order
					&& this.orderStore.order.recipes
					&& this.orderStore.order.recipes.length > 0
						? 'error'
						: 'info'

			errorStore.formatMessage(response, params)
			errorStore.updateType(type)
		}
	},

	mounted () {
		return plansStore.loadPlans()

		.then(response => {
			this.people = plansStore.getPeople({ plan_id: this.user.subscription.plan.id })

			return plansStore.findPlan({
				people: this.people,
				meals: Object.values(this.recipes).map(a => a.quantity).reduce((a, b) => a + b, 0)
			})
		})

		.catch(response => {
			this.errorHandle(response)
		})
	}
}

</script>

<style scoped>
.fake-dd-people {
	width: fit-content;
	font-size: 18px
}

[class*="fake-dd"] {
	text-align: left;
	display: inline-block;
}

[class*="fake-dd"] .fa {
	margin-left: 9px;
	font-weight: bold;
	font-size: 16px;
}

#select-op-btn {
	border-bottom: 1.5px dotted #399ec9;
	display: block;
	cursor: pointer;
	background-repeat: no-repeat;
	background-position: right center;
	font-weight: bold;
}

[class*="fake-dd"] {
	box-sizing: border-box;
	padding: 0 5px;
}

[class*="fake-dd"] > ul {
	position: absolute;
	z-index: 9;
	list-style-type: none;
	border: none;
	padding: 10px 0;
	background: white;
	padding: 5px 13px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

[class*="fake-dd"] > ul li {
	padding: 3px 8px;
	cursor: pointer;
}

[class*="fake-dd"] .js-drop {
	display: none;
}

</style>
